/* Filtrous catalog supplement - v8.3, 2026-08-27
   The storefront app + search band read the static assets/catalog-index.json
   (generated 2026-07-24), so products created after that build are invisible:
   the app hash-router falls back to the home view for their PDPs and family
   sheets skip them. This shim wraps window.fetch and splices the missing
   products into the catalog response at runtime (deduped by SKU, so it
   becomes a no-op once the generator ships a fresh index including them).
   v2 adds the 2026-08-06 Acumatica batch: tip boxes, beaker, syringe, syringe
   filters. CUF-00-0500-S was requested but has no Shopify product yet.
   v3 adds VLL-22-2200-K1 (20mL 22-400 scintillation vial, blue cap), created
   2026-08-07 and therefore absent from the index for the same reason.
   v4 adds EXK-MJ-0096 (Cannabis DNA/RNA Extraction Kit, 96 preps) so its PDP
   resolves; it is in the filtrous-v3.js PREORDER set, so it renders as
   Preorder (buyable) rather than In stock.
   v5 adds SFN-AQ-2030 (Nylon SVX syringe filter, 0.45um 32mm). Its product
   predates the index build but was never published to the Online Store, so
   the generator never saw it; published 2026-08-24. Removed from the
   filtrous-v3.js FORCE_OOS list in the same change (195 units on hand).
   v6 points SFN-AQ-2030 at the light-purple product photo set uploaded
   2026-08-24 (SFN-AQ-2030_lp_main.png, white background to match the other
   card photos); the old SFN-AQ-2030_-_Main.png still resolves but shows the
   pre-rebrand ring color.
   v7 adds IMG_OVERRIDES to correct card images for SKUs already present in
   the static index: CSS-10-5020's index entry points at the 1.5 mL conical
   tube photo; the product (and override) now use the correct 2.0 mL standing
   tube photo (CSS-10-5020-Main-2mL.png, swapped on the product 2026-08-24).
   v8 adds LIVE IMAGE HYDRATION (same philosophy as filtrous-live-stock.js:
   images must not be hardcoded). The 2026-08-14 index build predates the CHM
   chemistry-reagent photo upload (2026-08-25), so those entries carry
   image:"" and rendered the text placeholder. Instead of hand-listing URLs,
   any entry (spliced EXTRA items included) whose image is EMPTY is filled
   from Shopify's public /products/<handle>.js as the index loads - so future
   photo uploads appear with no code edit. Lookups run in parallel, cached
   24h in sessionStorage (misses cached too), capped at 2.5s so a slow
   network can never hold up first paint; on timeout the index loads with
   whatever resolved. IMG_OVERRIDES still wins - it exists to CORRECT a
   wrong-but-present image, which hydration (empty-only) can't. Becomes a
   no-op once a fresh index bakes real image URLs in.
   v8.1 bundles PDP IMAGE ZOOM at the end of this file: hover magnifies the
   gallery image 2.2x panning with the cursor; click/tap opens a full-screen
   lightbox of the full-res CDN photo (Esc / X / click closes). Bundled HERE,
   not as its own asset + loader line, so the whole feature ships in the ONE
   file edit this shim already requires; split it out to its own asset when
   someone is in the theme editor anyway. Binds only to the PDP main image
   (#fv3-app .fv3-pdp .fv3-gallery img), never the "Pairs with" cards.
   Additive asset; remove its loader line in sections/filtrous-v3-app.liquid
   to revert.
   v8.2 adds two IMG_OVERRIDES (wrong-but-present index images, which
   empty-only hydration can't touch): SSC-20-0100's index entry pointed at a
   2x500mL bottle photo; product re-shot 2026-08-25 as a single 1L bottle.
   PTF-GS-1250's entry points at a PTF-GS-0010 photo; override folded in from
   the never-deployed filtrous-catalog-image-overrides.js draft, which this
   supersedes. XSP-AE-0200 added same day: all four AccuPet Evo pipette SKUs
   shared one byte-identical photo of the 100-1000 ul model; the product got a
   corrected 20-200 ul photo 2026-08-25 (XSP-AE-0010/-0100 still pending).
   MBP-03-6030 added same day: 6x500mL ultrapure water six-pack re-shot with
   the new blue "Water / Ultrapure Grade" label design (was the old green
   "Ultrapure Water" label). MBP-07-3005 added same day: 2x500mL ethanol
   two-pack re-shot with the new blue label + NFPA 3/2/0 diamond; the old
   shot also carried the WRONG SKU (MBP-07-3010) on its labels.
   PCT-08-0102 added same day, hero revised 2026-08-26: all eight attached
   flat caps now shown CLOSED (one per tube, matching the description) in
   natural frosted PP; gallery is hero + bagged-strips shot per user's
   curation in admin. PCM-21-0096 added 2026-08-26: the unit ships with a
   blue applicator squeegee, so the films-only shot gained one (composited
   onto the existing photo; films unchanged). WKS-31-2020 added 2026-08-26:
   plate photos moved from blue to white backgrounds with a '2 mL' marking
   on the plate skirt (volume-labeling concern; main revised same day - first
   pass drew the text on a gray patch, second was too prominent; final is a
   faint embossed molding mark);
   spec table gained a Well volume row the same day. 6150-1100 added 2026-08-26: same new-packaging
   Ahlstrom box shot re-rendered on a pure white background (was gray).
   SFN-AP-2030's EXTRA image updated 2026-08-26: it pointed at the ARCHIVED
   duplicate product's pre-rebrand photo (and the active product's own image
   said 0.22 um on a 0.45 product); re-shot in the SVX-style single-filter
   3/4 composition, yellow GFP housing, 'NY 0.45 um'. NOTE: the 2026-08-14
   index rebuild now INCLUDES SFN-AP-2030 (with the old 0.22-labeled image),
   so its EXTRA entry is a no-op and the fix rides in IMG_OVERRIDES.
   v8.3 (Adelaide 2026-08-27) merges the duplicate PCR Kits CARD into
   PCR Kits & Reagents - see mergeFamilyCard() below. */
(function () {
  'use strict';
  var EXTRA = [
    { sku: 'SFN-AQ-2030', vid: '44256538427666', title: 'Nylon, Triple Layer (SVX) Syringe Filter, Non-Sterile, 0.45um, 32mm, 100/unit', handle: 'svx-nylon-syringe-filters-0-45um-32mm-100-unit-1', price: '180.00', available: true, image: 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/SFN-AQ-2030_lp_main.png?v=1787590294', families: ['syringe-filters-v2'], primary_family: 'syringe-filters-v2', specs: { pack_qty: 100, pore_size: 0.45, diameter: 32.0, membrane: 'Nylon', sterility: 'Non-Sterile' } },
    { sku: 'WBS-02-1010', vid: '52586469622034', title: 'Weigh Boats, 41 X 41mm, Anti-Static, 500/unit', handle: 'weigh-boats-41-x-41mm-anti-static-500-unit', price: '22.25', available: true, image: 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/WeighBoat41x41mmAnti-Static_cea17f71-4d35-4523-b381-49bf3f077f75.png?v=1786114574', families: ['weighing-v2'], primary_family: 'weighing-v2', specs: { pack_qty: 500, diameter: 41.0 } },
    { sku: 'WBS-01-1089', vid: '52586467721490', title: 'Weigh boats, 89 X 89mm, Anti-Static, 500/unit', handle: 'weigh-boats-89-x-89mm-anti-static-500-unit', price: '33.60', available: true, image: 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/WeighBoat89x89mmAnti-Static.png?v=1786114621', families: ['weighing-v2'], primary_family: 'weighing-v2', specs: { pack_qty: 500, diameter: 89.0 } },
    { sku: 'WBS-02-1250', vid: '52586467590418', title: 'Weigh boats, 140 X 140mm, Anti-Static, 250/unit', handle: 'weigh-boats-140-x-140mm-anti-static-250-unit', price: '25.00', available: true, image: 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/WeighBoat140x140mmAnti-Static.png?v=1786114458', families: ['weighing-v2'], primary_family: 'weighing-v2', specs: { pack_qty: 250, diameter: 140.0 } },
    { sku: 'TCB-00-0150', vid: '52586461724946', title: '150mL Polypropylene Graduated Beakers, Non-Sterile, 100/unit', handle: '150ml-polypropylene-graduated-beakers-non-sterile-100-unit-1', price: '102.90', available: true, image: 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/Beakers_f7a176c0-b9ab-4869-bcec-79657c953bb2.jpg?v=1718937335', families: ['glassware-plastics-v2'], primary_family: 'glassware-plastics-v2', specs: { volume_ml: 150, capacity_ml: 150, pack_qty: 100, material: 'Polypropylene', sterility: 'Non-Sterile' } },
    { sku: 'TBX-00-0010', vid: '52586467918098', title: '10uL Tip Empty Boxes, 10/unit', handle: '10ul-tip-empty-boxes-10-unit', price: '23.10', available: true, image: '', families: ['universal-tips-v2'], primary_family: 'universal-tips-v2', specs: { volume_ul: 10, pack_qty: 10 } },
    { sku: 'TBX-00-0200', vid: '52586468081938', title: '200uL Tip Empty Boxes, 10/unit', handle: '200ul-tip-empty-boxes-10-unit', price: '23.10', available: true, image: '', families: ['universal-tips-v2'], primary_family: 'universal-tips-v2', specs: { volume_ul: 200, pack_qty: 10 } },
    { sku: 'TBX-00-1000', vid: '52586468278546', title: '1000uL Tip Empty Boxes, 10/unit', handle: '1000ul-tip-empty-boxes-10-unit', price: '25.20', available: true, image: '', families: ['universal-tips-v2'], primary_family: 'universal-tips-v2', specs: { volume_ul: 1000, pack_qty: 10 } },
    { sku: 'LFN-11-0500', vid: '52586501308690', title: 'Luer Fixed Syringe, w/ Needle, Sterile, 0.5mL, 31G x 8mm, 100/unit', handle: 'luer-fixed-syringe-w-needle-sterile-0-5ml-31g-x-8mm-100-unit', price: '30.75', available: true, image: '', families: ['syringes-v2'], primary_family: 'syringes-v2', specs: { pack_qty: 100, sterility: 'Sterile' } },
    { sku: 'SFN-FW-2030', vid: '52586469523730', title: 'Cellulose Acetate, Triple Layer (SVX) Syringe Filter, Non-Sterile, 0.45um, 33mm, 100/unit', handle: 'cellulose-acetate-triple-layer-svx-syringe-filter-non-sterile-0-45um-33mm-100-unit', price: '103.95', available: true, image: '', families: ['syringe-filters-v2'], primary_family: 'syringe-filters-v2', specs: { pack_qty: 100, pore_size: 0.45, diameter: 33.0, membrane: 'Cellulose Acetate', sterility: 'Non-Sterile' } },
    { sku: 'SFN-AP-2030', vid: '52586475192594', title: 'Nylon, Double Layer (GFP) Syringe Filter, Non-Sterile, 0.45um, 30mm, 100/unit', handle: 'nylon-double-layer-gfp-syringe-filter-non-sterile-0-45um-30mm-100-unit', price: '157.50', available: true, image: 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/hf_20260826_144607_cc7f28d7-c17e-4d62-a8e8-c1a07916a81e.png?v=1787755650', families: ['syringe-filters-v2'], primary_family: 'syringe-filters-v2', specs: { pack_qty: 100, pore_size: 0.45, diameter: 30.0, membrane: 'Nylon', sterility: 'Non-Sterile' } },
    { sku: 'SFN-BW-1030', vid: '52586469687570', title: 'PTFE, Triple Layer (SVX) Syringe Filter, Non-Sterile, 0.22um, 30mm, 100/unit', handle: 'ptfe-triple-layer-svx-syringe-filter-non-sterile-0-22um-30mm-100-unit', price: '80.85', available: true, image: '', families: ['syringe-filters-v2'], primary_family: 'syringe-filters-v2', specs: { pack_qty: 100, pore_size: 0.22, diameter: 30.0, membrane: 'PTFE', sterility: 'Non-Sterile' } },
    { sku: 'VLL-22-2200-K1', vid: '52587292819730', title: 'Screw Top, 22-400, Scintillation, Clear Vial, w/o Patch, 20 mL, Closed, PTFE Silicone, Blue Cap, 100/unit', handle: 'screw-top-22-400-scintillation-clear-vial-w-o-patch-20-ml-closed-ptfe-silicone-blue-cap-100-unit', price: '63.00', available: true, image: 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/hf_20260807_190033_bea93c7a-9e92-485f-8b0d-5f3df2d2083f.png?v=1786129288', families: ['scintillation-vials-v2'], primary_family: 'scintillation-vials-v2', specs: { volume_ml: 20, capacity_ml: 20, pack_qty: 100, cap_thread: '22-400', membrane: 'PTFE', color: 'Clear', cap_color: 'Blue', material: 'Silicone', closure_type: 'Screw', cap_type: 'Screw', closure: 'Screw', septa_type: 'PTFE/Silicone', seal_material: 'Silicone', patch: false } },
    { sku: 'EXK-MJ-0096', vid: '51886049231122', title: 'Cannabis DNA/RNA Extraction Kit, 96 Preps/unit', handle: 'cannabis-universal-dna-rna-extraction-kit-96-preps-unit', price: '420.00', available: true, image: '', families: ['extraction-kits-v2'], primary_family: 'extraction-kits-v2', specs: { rxn_count: 96, prep_count: 96, target_nucleic: 'DNA', item_type: 'Kit' } }
  ];
  var IMG_OVERRIDES = {
    'CSS-10-5020': 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/CSS-10-5020-Main-2mL.png?v=1787591973',
    'SSC-20-0100': 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/hf_20260825_215547_066f7e8c-fb4e-4e01-b5e3-d6e3b32aa563.png?v=1787695004',
    'PTF-GS-1250': 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/PTF-GS-1250_-_Main.png?v=1787581857',
    'XSP-AE-0200': 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/hf_20260825_221709_60ae151c-5f59-48e0-b0c3-5b54438a1901.png?v=1787696312',
    'MBP-03-6030': 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/hf_20260825_222803_f1e7a420-c313-40df-861e-629538f0df45.png?v=1787696978',
    'MBP-07-3005': 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/hf_20260825_223741_e2568985-6f17-41e8-b585-b5d6718d5b3f.png?v=1787697592',
    'PCT-08-0102': 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/hf_20260826_133748_e3685875-cf53-4f11-bfe0-2411c3d972ce.png?v=1787751583',
    'WKS-31-2020': 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/hf_20260826_143405_83aa1845-6128-4203-8e6f-9c0b33162a92.png?v=1787755115',
    '6150-1100': 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/hf_20260826_142341_692ed2b7-aac9-47de-a566-88f622690dcc.png?v=1787754343',
    'SFN-AP-2030': 'https://cdn.shopify.com/s/files/1/0684/8823/3234/files/hf_20260826_144607_cc7f28d7-c17e-4d62-a8e8-c1a07916a81e.png?v=1787755650'
  };
  var IMG_CACHE_KEY = 'fv3-live-img';
  var IMG_TTL_MS = 24 * 60 * 60 * 1000;
  var IMG_BUDGET_MS = 2500;
  var orig = window.fetch;
  if (!orig) return;

  /* Fill empty item.image from Shopify's public product JSON (/products/
     <handle>.js - no token, same origin). Empty-only: never touches an
     image the index or IMG_OVERRIDES already set. Resolves with `data`
     no matter what; failures just leave the placeholder for this visit. */
  function hydrateImages(data) {
    var cache = {};
    try { cache = JSON.parse(sessionStorage.getItem(IMG_CACHE_KEY) || '{}'); } catch (e) {}
    var now = Date.now();
    var pending = [];
    data.products.forEach(function (p) {
      if (!p || !p.sku || !p.handle || p.image) return;
      var c = cache[p.sku];
      if (c && (now - c.t) < IMG_TTL_MS) { if (c.u) p.image = c.u; return; }
      pending.push(p);
    });
    if (!pending.length) return Promise.resolve(data);
    var work = pending.map(function (p) {
      return orig('/products/' + p.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var u = (j && (j.featured_image || (j.images && j.images[0]))) || '';
          if (u.indexOf('//') === 0) u = 'https:' + u;   // product.js URLs are protocol-relative
          cache[p.sku] = { t: now, u: u };               // misses cached too - no refetch storm for imageless products
          if (u) p.image = u;
        })
        .catch(function () { /* leave uncached; retried next load */ });
    });
    var budget = new Promise(function (res) { setTimeout(res, IMG_BUDGET_MS); });
    return Promise.race([Promise.all(work), budget]).then(function () {
      try { sessionStorage.setItem(IMG_CACHE_KEY, JSON.stringify(cache)); } catch (e) {}
      return data;
    });
  }

  /* ---- Category-card merge (Adelaide 2026-08-27) ----------------------
     "PCR & Consumables > PCR Kits & Reagents" listed TWO near-identical
     leaves: PCR Kits (21 SKUs) and PCR Kits & Reagents (the same 21 plus
     EXK-BD-0096-PP), so the family grid showed the category twice. This
     retires the PCR Kits CARD and keeps PCR Kits & Reagents, first copying
     over any product the survivor is missing (none today - all 21 are
     already members - but the copy keeps the merge honest if the index
     changes). The retired FAMILY itself is left in the index, so
     #/f/pcr-kits-v2 and /collections/pcr-kits-v2 still resolve; only the
     duplicate card goes.
     Card art must stay the PCR-KIT photo, not the extraction kit's: both
     renderers (computeImages() in filtrous-home-families.js and the tile
     loop in filtrous-v3.js) take the FIRST product in index order that
     carries the family AND has an image, so the kit is moved ahead of
     EXK-BD-0096-PP in data.products. That move is the ONLY reordering and
     it does not touch sheet row order, which sorts by part number.
     No-op once the leaf is gone from a freshly generated index. Fold the
     merge into the generator and delete this block to revert. */
  var CARD_MERGES = [{ from: 'pcr-kits-v2', into: 'pcr-kits-reagents-v2' }];

  function eachLeaf(data, fn) {
    var deps = data.departments || [], i, j, k;
    for (i = 0; i < deps.length; i++) {
      var cats = deps[i].categories || [];
      for (j = 0; j < cats.length; j++) {
        var leaves = cats[j].leaves || [];
        for (k = leaves.length - 1; k >= 0; k--) fn(leaves[k], leaves, k);
      }
    }
  }

  function mergeFamilyCard(data, from, into) {
    // never drop the card unless the survivor is actually there to absorb it
    var survives = false;
    eachLeaf(data, function (lf) { if (lf.handle === into) survives = true; });
    if (!survives) return;

    var dropped = false, i;
    eachLeaf(data, function (lf, leaves, k) {
      if (lf.handle === from) { leaves.splice(k, 1); dropped = true; }
    });
    if (!dropped) return;   // fresh index already merged - nothing to do

    var products = data.products || [], kitIdx = -1;
    for (i = 0; i < products.length; i++) {
      var p = products[i], fams = p && p.families;
      if (!fams || fams.indexOf(from) < 0) continue;
      if (fams.indexOf(into) < 0) fams.push(into);
      if (p.image && kitIdx < 0) kitIdx = i;
    }

    // hoist the kit above the survivor's current first-with-image entry
    var intoIdx = -1;
    for (i = 0; i < products.length; i++) {
      var q = products[i];
      if (q && q.image && q.families && q.families.indexOf(into) >= 0) { intoIdx = i; break; }
    }
    if (kitIdx > -1 && intoIdx > -1 && kitIdx > intoIdx) {
      products.splice(intoIdx, 0, products.splice(kitIdx, 1)[0]);
    }

    // survivor's count follows its real membership
    var n = 0;
    for (i = 0; i < products.length; i++) {
      var r = products[i];
      if (r && r.families && r.families.indexOf(into) >= 0) n++;
    }
    eachLeaf(data, function (lf) { if (lf.handle === into) lf.count = n; });
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (String(url).indexOf('catalog-index') === -1) return orig.apply(this, arguments);
    return orig.apply(this, arguments).then(function (res) {
      if (!res || !res.ok) return res;
      return res.clone().json().then(function (data) {
        if (!data || !data.products || !data.products.length) return res;
        var have = {};
        data.products.forEach(function (p) {
          if (!p || !p.sku) return;
          have[p.sku] = 1;
          if (IMG_OVERRIDES[p.sku]) p.image = IMG_OVERRIDES[p.sku];
        });
        var added = 0;
        EXTRA.forEach(function (p) { if (!have[p.sku]) { data.products.push(p); added++; } });
        if (added) {
          if (typeof data.catalog_sku_count === 'number') data.catalog_sku_count += added;
          if (typeof data.reachable_sku_count === 'number') data.reachable_sku_count += added;
        }
        CARD_MERGES.forEach(function (m) { mergeFamilyCard(data, m.from, m.into); });
        return hydrateImages(data).then(function (data) {
          return new Response(JSON.stringify(data), { status: res.status, statusText: res.statusText, headers: { 'Content-Type': 'application/json' } });
        });
      }).catch(function () { return res; });
    });
  };
})();

/* ---- PDP image zoom (v8.1) ---- */
(function () {
  'use strict';
  var ZOOM = 2.2;

  var css = document.createElement('style');
  css.textContent =
    '.fvz-box{overflow:hidden;cursor:zoom-in}' +
    '.fvz-box img{transition:transform .18s ease-out;transform-origin:center center}' +
    '#fvz-lightbox{position:fixed;inset:0;z-index:99999;background:rgba(6,35,52,.82);display:flex;align-items:center;justify-content:center;cursor:zoom-out;padding:4vh 4vw}' +
    '#fvz-lightbox img{max-width:100%;max-height:100%;object-fit:contain;background:#fff;border-radius:10px}' +
    '#fvz-lightbox .fvz-close{position:absolute;top:18px;right:22px;width:40px;height:40px;border:0;border-radius:50%;background:rgba(255,255,255,.92);color:#062334;font-size:20px;font-weight:700;line-height:1;cursor:pointer}';
  document.head.appendChild(css);

  function openLightbox(src, alt) {
    if (document.getElementById('fvz-lightbox')) return;
    var ov = document.createElement('div');
    ov.id = 'fvz-lightbox';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-label', 'Product image zoom');
    var img = document.createElement('img');
    img.src = src;
    img.alt = alt || '';
    var x = document.createElement('button');
    x.className = 'fvz-close';
    x.setAttribute('aria-label', 'Close');
    x.textContent = '×';
    ov.appendChild(img);
    ov.appendChild(x);
    function close() {
      ov.remove();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    ov.addEventListener('click', close);
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    document.body.appendChild(ov);
  }

  function arm(img) {
    if (img.dataset.fvz) return;
    img.dataset.fvz = '1';
    var box = img.closest('.fv3-gallery');
    if (!box) return;
    box.classList.add('fvz-box');
    box.addEventListener('mousemove', function (e) {
      var r = box.getBoundingClientRect();
      img.style.transformOrigin =
        ((e.clientX - r.left) / r.width * 100) + '% ' +
        ((e.clientY - r.top) / r.height * 100) + '%';
      img.style.transform = 'scale(' + ZOOM + ')';
    });
    box.addEventListener('mouseleave', function () { img.style.transform = 'none'; });
    box.addEventListener('click', function () {
      img.style.transform = 'none';
      openLightbox(img.currentSrc || img.src, img.alt);
    });
  }

  function scan() {
    var imgs = document.querySelectorAll('#fv3-app .fv3-pdp .fv3-gallery img');
    for (var i = 0; i < imgs.length; i++) arm(imgs[i]);
  }

  function boot() {
    scan();
    new MutationObserver(scan)
      .observe(document.getElementById('fv3-app') || document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ---- v9: LIVE IMAGES — nothing about images is baked ---- (v9.1: page-URL fallback
   limited to the PDP gallery; see handleFor. v9.2: a stale cache can no longer
   overwrite a newer image; see liveImage)
   v9.3 (2026-09-17): PCM-21-0096 dropped from IMG_OVERRIDES. Its override was
   the 2026-08-26 render WITH the blue squeegee; the product and the index now
   carry PCM-21-0096-white-v1.png (squeegee removed) and the override was putting
   the old picture back on first paint. Every other entry still matches the index.
   The catalog index still ships an image URL, but only so the first paint has
   something to draw. Shopify is the authority. Every catalog image that scrolls
   into view is checked against /products/<handle>.js and swapped if the
   product's featured image has changed, so a photo swapped in admin appears on
   the next page view with no index rebuild and no IMG_OVERRIDES entry. Same
   philosophy as filtrous-live-stock.js and the live price module.

   v8's hydrateImages() stays: it fills entries the index left EMPTY at load
   time, which keeps the text placeholder from ever flashing. This block covers
   the other case v8 could not — an image that is present but wrong.

   IMG_OVERRIDES above is now a first-paint hint only. A wrong entry there
   corrects itself here rather than shipping to shoppers, so the table no longer
   needs hand-maintaining when a product photo is replaced.

   Cost control:
   - only <img> whose src is a Shopify files CDN URL is ever touched, so logos,
     banners and art assets are never fetched or swapped
   - one /products/<handle>.js (~3.4 KB) per product, cached 24h in
     sessionStorage and shared by every card pointing at that handle
   - only images within 300px of the viewport are checked
   - the DOM is written only on a real difference, so unchanged images (the
     overwhelming majority) never repaint
   - every failure is silent and leaves the first-paint image in place */
(function () {
  'use strict';

  if (window.__fv3LiveImg) return;
  window.__fv3LiveImg = true;

  var KEY = 'fv3-live-img-v9';
  var TTL = 24 * 60 * 60 * 1000;
  var CDN = /(^|\/\/)cdn\.shopify\.com\/s\/files\//;
  var inflight = {};

  function cacheRead() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) { return {}; }
  }
  function cacheWrite(c) {
    try { sessionStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {}
  }

  /* Compare on the CDN filename: the ?v= stamp changes on re-upload without the
     picture changing, and swapping on that alone would repaint for nothing. */
  function fileOf(u) {
    return String(u || '').split('?')[0].split('/').pop();
  }

  function handleFor(img) {
    var a = img.closest('a[href*="/products/"]');
    if (a) {
      var m = String(a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    }
    /* PDP hero (.fv3-gallery) sits outside any product link. v9.1 2026-09-10
       (Adelaide): ONLY the gallery may fall back to the page URL. Before, any
       CDN <img> with no product link inherited the page's handle - so on a
       product page every cart-drawer thumbnail (not linked) was repainted with
       the open product's photo: PTF-LS-0010 in the drawer showed EXK-BD-0096's
       kit. Other unlinked images are left exactly as rendered. */
    if (!img.closest('.fv3-gallery')) return null;
    var m2 = location.pathname.match(/\/products\/([^/?#]+)/);
    return m2 ? m2[1] : null;
  }

  /* v9.2 2026-09-16 (Adelaide): a cache hit is trusted ONLY when it agrees with
     the file the page already painted. If they differ, the entry is stale or
     the photo just changed - either way Shopify is asked again instead of the
     cache winning. Before this, a tab that had seen the OLD photo kept pushing
     it back over the new one for up to 24h (FPH-38 v4 over v5, seen in the
     theme preview the day the plates were re-cut). Costs one fetch, and only
     on a disagreement. */
  function liveImage(handle, curFile) {
    var cache = cacheRead();
    var hit = cache[handle];
    if (hit && (Date.now() - hit.t) < TTL && (!curFile || !hit.u || fileOf(hit.u) === curFile)) return Promise.resolve(hit.u);
    if (inflight[handle]) return inflight[handle];

    inflight[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var u = (j && (j.featured_image || (j.images && j.images[0]))) || '';
        if (typeof u === 'string' && u.indexOf('//') === 0) u = location.protocol + u;
        var c = cacheRead();
        c[handle] = { u: u, t: Date.now() };   /* misses cached too, so a 404 is asked once */
        cacheWrite(c);
        return u;
      })
      .catch(function () { return ''; })
      .then(function (u) { delete inflight[handle]; return u; });

    return inflight[handle];
  }

  function apply(img, url) {
    if (!url || fileOf(url) === fileOf(img.currentSrc || img.src)) return;
    /* srcset would win over src, and a <picture> <source> would win over both */
    var pic = img.parentElement;
    if (pic && pic.tagName === 'PICTURE') {
      var srcs = pic.querySelectorAll('source');
      for (var i = 0; i < srcs.length; i++) srcs[i].parentNode.removeChild(srcs[i]);
    }
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.src = url;
  }

  function verify(img) {
    if (img.hasAttribute('data-fv3-live-img-done')) return;
    img.setAttribute('data-fv3-live-img-done', '1');
    var src = img.currentSrc || img.src || '';
    if (!CDN.test(src)) return;
    var h = handleFor(img);
    if (!h) return;
    liveImage(h, fileOf(src)).then(function (u) { apply(img, u); });
  }

  /* Viewport test by rect rather than IntersectionObserver. IO does not fire in
     a prerendered or non-rendered document, which would leave images unverified
     on exactly the pages instant.page warms up; an explicit rect check behaves
     the same everywhere and costs one layout read per unverified image. */
  function near(img) {
    var r = img.getBoundingClientRect();
    if (!r.width && !r.height) return false;
    return r.bottom > -300 && r.top < (innerHeight || 0) + 300 &&
           r.right > -300 && r.left < (innerWidth || 0) + 300;
  }

  function sweep() {
    /* Never touch storage or fetch inside a prerender - see the instant.page
       rule in filtrous-live-stock.js. prerenderingchange re-runs this. */
    if (document.prerendering) return;
    var imgs = document.querySelectorAll('img[data-fv3-live-img-seen]:not([data-fv3-live-img-done])');
    for (var i = 0; i < imgs.length; i++) if (near(imgs[i])) verify(imgs[i]);
  }

  function scan() {
    var imgs = document.querySelectorAll('img:not([data-fv3-live-img-seen])');
    for (var i = 0; i < imgs.length; i++) imgs[i].setAttribute('data-fv3-live-img-seen', '1');
    sweep();
  }

  /* The V3 app mutates heavily while rendering a grid; coalesce so one render
     costs one pass, not one per node inserted. */
  var pending = 0;
  function soon() {
    if (pending) return;
    pending = setTimeout(function () { pending = 0; scan(); }, 100);
  }

  function boot() {
    scan();
    new MutationObserver(soon)
      .observe(document.getElementById('fv3-app') || document.body, { childList: true, subtree: true });
    addEventListener('scroll', soon, { passive: true });
    addEventListener('resize', soon);
    document.addEventListener('visibilitychange', soon);
    document.addEventListener('prerenderingchange', soon);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
